import { lazy, Suspense } from "react";
import { useAssistant } from "@/assistant/AssistantProvider";

const AssistantSheet = lazy(() => import("./AssistantSheet").then((m) => ({ default: m.AssistantSheet })));
const VoiceMode = lazy(() => import("./VoiceMode").then((m) => ({ default: m.VoiceMode })));

/** The sheet and voice screen, loaded only where the assistant is available. */
export function AssistantSurfaces() {
  const a = useAssistant();
  if (!a.available) return null;
  return (
    <Suspense fallback={null}>
      <AssistantSheet />
      {a.voice ? <VoiceMode /> : null}
    </Suspense>
  );
}
